import React, { useEffect, useState } from "react";
import { LoginSocialGoogle } from "reactjs-social-login";
import { getAuthToken } from "../../middleware/localStroage";
import { useNavigate } from "react-router-dom";
import { googleAuth, loginAuth } from "../../services/auth";
import loginimage from "../../assests/images/RegisterImage.png";
import logostart from "../../assests/images/logostart.png";
import eyeOn from "../../assests/images/view.png";
import eyeOff from "../../assests/images/hide.png";
import { toastError, toastSuccess } from "../../config/ToastModal";
import { setAuthorization } from "../../config/axios";
import { socketConnect } from "../../config/helper";
const initialFormValue = {
  email: "",
  password: "",
};

const Login = () => {
  const router = useNavigate();
  const token = getAuthToken();
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState(initialFormValue);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [errorshow, setErrorShow] = useState(false);
  const [previousPath, setPreviousPath] = useState("");

  const { email, password } = formValue;

  // useEffect(() => {
  //   const storedPath = localStorage.getItem("prevPath");
  //   if (storedPath) setPreviousPath(storedPath);
  // }, []);

  // useEffect(() => {
  //   if (token) {
  //     router.push(previousPath || "/dashboard");
  //   } else {
  //     if (window.location.pathname == "/reset-password") {
  //       window.location.replace(window.location.href);
  //     } else {
  //       router.push("/");
  //     }
  //   }
  // }, [token, previousPath, router]);

  // useEffect(() => {
  //   if (router.pathname === "/reset-password") {
  //     router.reload();
  //   }
  // }, []);

  const handleChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const handleSumbitData = async () => {
    setLoading(true);
    try {
      if (!email || !password) {
        setErrorShow(true);
        setLoading(false);
        return;
      }
      if (email && password) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emailRegex.test(email)) {
          setErrorShow(false);
          const data = { email, password };
          const response = await loginAuth(data);
          if (response.status) {
            setAuthorization(response.token);
            toastSuccess(response.message);
            router("/dashboard");
            setLoading(false);
            socketConnect();
          } else {
            for (let [a, b] of Object.entries(response.errors)) {
              toastError(b);
            }
            setLoading(false);
          }
        } else {
          toastError("Please Enter Valid Email ID");
        }
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleGoogleAuth = async (data) => {
    try {
      if (data) {
        const authData = {
          name: data.name,
          email: data.email,
          profile: data.picture,
          subId: data.sub,
        };

        const response = await googleAuth(authData);
        if (response?.status) {
          setAuthorization(response.token);
          toastSuccess(response.message);
          router("/dashboard");
        }
      }
    } catch (error) {
      toastError("Google login failed");
    }
  };

  const navigateRegisterPage = () => {
    router("/register");
  };

  const navigateForgetpassword = () => {
    router("/forgot-password");
  };

  useEffect(() => {
    if (token) {
      router("/dashboard");
    }
  }, [token]);

  return (
    <div className="login-section">
      <div
        className="image-layer"
        style={{
          padding: "40px",
          borderRight: "2px solid #f3f4f5",
        }}
      >
        <img src={loginimage} alt="no image" />
      </div>

      <div className="outer-box">
        {/* <!-- Login Form --> */}
        <div className="login-form default-form">
          <section className="form-inner">
            <div className="text-center d-flex align-items-center justify-content-center">
              <img
                src={logostart}
                alt="no image"
                style={{
                  width: "70%",
                  // height:"20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </div>
            <div className="text-center mb-4">
              <h4
                className="text-center mb-5 fw-bold"
                style={{ color: "#97144d" }}
              >
                Recruiter-HR Login
              </h4>
            </div>

            <div className="text-danger">
              {errorshow && "Please fill in all fields"}
            </div>

            <div className="form-group">
              <label>
                Email ID <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={handleChange}
                placeholder="Email ID"
              />
            </div>

            <div className="form-group mt-3">
              <label>
                Password <span className="text-danger">*</span>
              </label>
              <div className="password-section">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  name="password"
                  value={password}
                  onChange={handleChange}
                  placeholder="Password"
                />
                <img
                  src={isPasswordVisible ? eyeOn : eyeOff}
                  className="password-icon"
                  alt="toggle password"
                  onClick={togglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>

            <div className="form-group mt-3">
              <button
                className="theme-btn btn-style-one"
                onClick={handleSumbitData}
              >
                {loading ? "Loading..." : "Login Now"}
              </button>
            </div>

            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
              <div className="text mb-2 mb-md-0">
                Don't have an account?{" "}
                <span
                  onClick={navigateRegisterPage}
                  className="register"
                  style={{
                    cursor: "pointer",
                    color: "#828282",
                    fontWeight: "600",
                  }}
                >
                  Register
                </span>
              </div>
              <div
                className="register"
                onClick={navigateForgetpassword}
                style={{
                  color: "#2874f0",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                Forgot Password?
              </div>
            </div>

            <div className="text-center mt-3">or</div>

            <div className="form-group mt-2">
              <LoginSocialGoogle
                client_id={process.env.REACT_APP_API_GOOGLE_KEY}
                onResolve={({ data }) => handleGoogleAuth(data)}
                onReject={() => toastError("Google login failed")}
                scope="openid profile email"
              >
                <div className="btn-box row">
                  <div
                    className="col-lg-12 col-md-12"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="theme-btn social-btn-two google-btn">
                      <i className="fab fa-google"></i> {"Login in with Google"}
                    </div>
                  </div>
                </div>
              </LoginSocialGoogle>
            </div>
          </section>
        </div>
        {/* <!--End Login Form --> */}
      </div>
    </div>
  );
};

export default Login;
